import Toggle from './Toggle';
import toggleStyles from './toggle.module.scss';

export { Toggle, toggleStyles };

export default Toggle;
